export default __webpack_public_path__ + "static/media/typeGenerator.98bbde9e.98bbde9e.svg";